// RubberBoardRegistration.jsx
import React from "react";

export default function RubberBoardRegistration() {
  return (
    <div className="min-h-screen bg-white">
      {/* HERO SECTION */}
      <section className="max-w-6xl mx-auto px-4 py-12 grid md:grid-cols-2 gap-10 items-center">
        {/* Left: Text */}
        <div>
          <p className="text-sm tracking-[0.25em] text-gray-500 uppercase mb-3">
            Rubber Board Registration
          </p>
          <h1 className="text-3xl md:text-4xl font-bold mb-4 text-gray-900">
            Rubber Board Registration for Manufacturers & Exporters
          </h1>
          <div className="w-20 h-1 bg-yellow-500 mb-6" />
          <p className="text-gray-700 mb-4">
            Hawkins &amp; Brooks assists manufacturers and exporters with Rubber
            Board Registration as per statutory requirements under the Rubber
            Act, ensuring compliance for rubber production, processing, and trade.
          </p>
          <p className="text-gray-700">
            From eligibility assessment and application preparation to document
            submission through the Rubber Board portal and license issuance, the
            process is handled efficiently for seamless regulatory compliance.
          </p>
        </div>

        {/* Right: Image (square for consistency - Different image) */}
        <div className="relative">
          <div className="absolute -inset-4 border border-yellow-400 rounded-3xl opacity-40 hidden md:block" />
          <div className="relative rounded-3xl overflow-hidden shadow-xl border border-gray-100">
            <img
              src="https://images.pexels.com/photos/1570610/pexels-photo-1570610.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Rubber manufacturing and Rubber Board compliance"
              className="w-full aspect-square object-cover"
            />
          </div>
        </div>
      </section>

      {/* DOCUMENTS & WHY CHOOSE US SECTION */}
      <section className="border-t border-gray-100 bg-white">
        <div className="max-w-6xl mx-auto px-4 py-10 grid md:grid-cols-2 gap-12">
          {/* Documents required */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Documents Required for Rubber Board Registration
            </h2>
            <p className="text-gray-700 mb-4">
              Hawkins &amp; Brooks helps compile the essential business and
              operational documentation required for Rubber Board license
              registration through the official online portal.
            </p>
            <div className="bg-gray-50 border border-yellow-100 rounded-xl p-5">
              <ul className="space-y-2 text-gray-800 list-disc list-inside">
                <li>Business registration proof (GST certificate, incorporation certificate, or partnership deed).</li>
                <li>PAN card of proprietor, partners, or company directors.</li>
                <li>
                  Manufacturing or trading details including product list,
                  production capacity, export records, and machinery details.
                </li>
              </ul>
            </div>
          </div>

          {/* Why choose us */}
          <div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Why Choose Hawkins &amp; Brooks?
            </h2>
            <p className="text-gray-700 mb-4">
              The firm offers specialized support for Rubber Board compliance
              with deep knowledge of the rubber sector's statutory requirements.
            </p>
            <div className="space-y-3">
              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Sector-Specific Regulatory Knowledge
                </h3>
                <p className="text-gray-700 text-sm">
                  Expertise in Rubber Act provisions, Rubber Board procedures,
                  and compliance requirements for manufacturers, processors, and
                  exporters in the rubber industry value chain.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Smooth Compliance Handling
                </h3>
                <p className="text-gray-700 text-sm">
                  Efficient application preparation, portal filing, document
                  verification, and follow-up to ensure timely Rubber Board
                  license approval without delays.
                </p>
              </div>

              <div className="border-l-4 border-yellow-500 bg-white shadow-sm rounded-r-xl p-4">
                <h3 className="font-semibold text-gray-900 mb-1">
                  Trusted Professional Assistance
                </h3>
                <p className="text-gray-700 text-sm">
                  End-to-end support from initial eligibility check through
                  registration completion, license issuance, and ongoing
                  compliance advisory for rubber sector statutory obligations.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="mt-6 flex flex-wrap gap-3">
              <a
                href="/contact"
                className="inline-flex items-center justify-center px-6 py-2.5 rounded-full bg-green-500 text-black font-semibold shadow hover:bg-green-400 transition-colors text-sm"
              >
                Get Consultation
              </a>
              <a
                href="tel:+919217468906"
                className="inline-flex items-center justify-center px-5 py-2.5 rounded-full border border-yellow-500 text-yellow-600 font-medium hover:bg-yellow-50 transition-colors text-sm"
              >
                Call Hawkins &amp; Brooks
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
